import { PayloadAction } from '../../../../store.model';
import { ViewGroup } from '../model/view-group.model';
import { ActionType } from '../task-list-dialog.action';
import { TaskListDialogState } from '../task-list-dialog.state';

import { DeleteItem } from './delete-item.action';

export function deleteItemReducer(
    state: TaskListDialogState,
    action: PayloadAction<ActionType, DeleteItem>,
): TaskListDialogState {
    try {
        const nextTasks = state.tasks.filter((t) => {
            return t.msftTaskId !== action.payload.msftTaskId;
        });
        const nextGroups = state.groups.map<ViewGroup>((g) => {
            return {
                ...g,
                tasks: g.tasks.filter((t) => {
                    return t.msftTaskId !== action.payload.msftTaskId;
                }),
            };
        });
        return {
            ...state,
            tasks: nextTasks,
            groups: nextGroups,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
